import { memo, ReactElement, useCallback, useMemo } from 'react';
import { Button, Dropdown, MenuProps } from 'antd';
import { ApiOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import { ActionEntityType } from '@pmp/api';
import { ImportMatchingButtonProps } from './interfaces';

export const ImportMatchingButton = memo(({ entityTypes, loading, onConfig }: ImportMatchingButtonProps): ReactElement => {
  const { t } = useTranslation();

  const onClick = useCallback(
    ({ key }: { key: string }) => {
      onConfig(key as ActionEntityType);
    },
    [onConfig],
  );

  const items: MenuProps['items'] = useMemo(
    () => entityTypes.map(entityType => ({ key: entityType, label: t(`pmp.entities.${entityType}`) })),
    [entityTypes, t],
  );

  return (
    <Dropdown menu={{ items, onClick }} placement="bottomLeft" trigger={['click']}>
      <Button icon={<ApiOutlined />} loading={loading}>
        {t('global.buttons.importConfigMatching')}
      </Button>
    </Dropdown>
  );
});
